export default __webpack_public_path__ + "static/media/allLives.1b776dd0.jpg";